import {createApp} from "vue";
import App from "./App.vue";
import "./registerServiceWorker";
// import router from "./router";
// import store from "./store";

import {createBootstrap} from 'bootstrap-vue-next'
// Add the necessary CSS
import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue-next/dist/bootstrap-vue-next.css'

createApp(App)
    // .use(store)
    // .use(router)
    .use(createBootstrap)
    .mount("#app");
